// extracted by mini-css-extract-plugin
module.exports = {"link":"MojosMojoContent_link__35MBo","bidRow":"MojosMojoContent_bidRow__2FUp2","currentBidCol":"MojosMojoContent_currentBidCol__38yBS"};